// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"defe3b37","213":"a030f2ee"}[chunkId] + ".chunk.js";
};